'use client'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Controller } from 'react-hook-form'
import { LoginFormValues } from '../../_schema/types'
import { useLoginForm } from '../../_hooks/login/useLoginForm'

interface LoginModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  loading: boolean
  onSubmit: (values: LoginFormValues) => void
}

export const LoginModal = ({
  open,
  setOpen,
  loading,
  onSubmit,
}: LoginModalProps) => {
  const { control, handleSubmit, errors } = useLoginForm({
    email: '',
    password: '',
  })

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[35rem] bg-white">
        <DialogHeader className="mb-6">
          <DialogTitle className="text-xl font-normal text-center">
            ログイン
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="text-sm font-medium">
            CANADA GOOSE Generationsをご利用のお客様は、カナダグース日本公式サイトへの会員登録が必要です。会員登録がお済みでないお客様は
            <a
              href="https://www.canadagoose.jp/customer/register"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              カナダグース日本公式サイトで会員登録
            </a>
            を行った後、CANADA GOOSE
            Generationsに再度アクセスし、ログインしてください。
          </div>

          <div className="space-y-1">
            <label className="text-sm">メールアドレス</label>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="email"
                  className="border border-[#C9C9C9] bg-[#FBFBFB] focus:border-black"
                />
              )}
            />
            {errors.email && (
              <p className="text-red-500 text-xs">{errors.email.message}</p>
            )}
          </div>

          <div className="space-y-1">
            <label className="text-sm">パスワード</label>
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="password"
                  className="border border-[#C9C9C9] bg-[#FBFBFB] focus:border-black"
                />
              )}
            />
            {errors.password && (
              <p className="text-red-500 text-xs">{errors.password.message}</p>
            )}
          </div>

          <div className="text-center mt-2">
            パスワードをお忘れの方は
            <a
              href="https://www.canadagoose.jp/password_reminder_input"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 hover:underline"
            >
              こちら
            </a>
          </div>

          <div className="flex justify-center">
            <Button
              type="submit"
              className="w-[90%] bg-black hover:bg-black/90 rounded-none h-12"
              disabled={loading}
            >
              {loading ? '処理中...' : 'ログイン'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default LoginModal
